// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeopleFullBodySolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
    />
    <path
      fill="currentColor"
      d="M10.306 22H8.259a.5.5 0 0 1-.496-.561l1.3-10.5-4.655-.873a.5.5 0 0 1-.4-.583l.37-1.966a.5.5 0 0 1 .583-.4l5.758 1.08c.487.092.787.137 1.281.137.494 0 .803-.045 1.29-.137l5.758-1.08a.5.5 0 0 1 .583.4L20 9.483a.5.5 0 0 1-.4.583l-4.655.873 1.301 10.5a.5.5 0 0 1-.496.561h-2.047a.5.5 0 0 1-.484-.375L12 16.185l-1.21 5.44a.5.5 0 0 1-.484.375z"
    />
  </svg>
);
export default SvgPeopleFullBodySolid;
